import { GET_COMPONENT_FILE, GetComponentFile } from "../types/file/get-component-file.dto";
import { GET_COURSE_FILE, GetCourseFile } from "../types/file/get-course-file.dto";
import { GET_UNIT_FILE, GetUnitFile } from "../types/file/get-unit-file.dto";


export const getCourseFile = (payload): GetCourseFile => {
  return { type: GET_COURSE_FILE, payload };
};

export const getUnitFile = (payload): GetUnitFile => {
  return { type: GET_UNIT_FILE, payload };
};

export const getComponentFile = (payload): GetComponentFile => {
  return { type: GET_COMPONENT_FILE, payload };
};
